export default "/dist/fonts/Roboto-Medium.ttf";